import { type } from '@/utils/type'


export const MESURETYPE_REQUEST = type('MESURETYPE_REQUEST')
export const MESURETYPE_SUCCESS = type('MESURETYPE_SUCCESS')
export const MESURETYPE_ERROR = type('MESURETYPE_ERROR')

export const MESURETYPE_ENSURE_LIST = type('MESURETYPE_ENSURE_LIST')

export const MESURETYPE_SELECT_DETAIL_REQUEST = type('MESURETYPE_SELECT_DETAIL_REQUEST')
export const MESURETYPE_SELECT_DETAIL_SUCCESS = type('MESURETYPE_SELECT_DETAIL_SUCCESS')
export const MESURETYPE_SELECT_DETAIL_ERROR = type('MESURETYPE_SELECT_DETAIL_ERROR')
export const MESURETYPE_SELECT_DETAIL = type('MESURETYPE_SELECT_DETAIL')

export const MESURETYPE_SAVE_REQUEST = type('MESURETYPE_SAVE_REQUEST')
export const MESURETYPE_SAVE_SUCCESS = type('MESURETYPE_SAVE_SUCCESS')
export const MESURETYPE_SAVE_ERROR = type('MESURETYPE_SAVE_ERROR')

export const MESURETYPE_UPDATE_MODIFIED_ADM = type('MESURETYPE_UPDATE_MODIFIED_ADM')
export const MESURETYPE_CANCEL_MODIFIED_ADM = type('MESURETYPE_CANCEL_MODIFIED_ADM')

export const MESURETYPE_UPDATE_FILTER_ADM = type('MESURETYPE_UPDATE_FILTER_ADM')